export default __webpack_public_path__ + "static/media/check_icon.99eb7df2.svg";